import { render, staticRenderFns } from "./TopicDesc.vue?vue&type=template&id=53bea329&scoped=true&"
import script from "./TopicDesc.vue?vue&type=script&lang=js&"
export * from "./TopicDesc.vue?vue&type=script&lang=js&"
import style0 from "./TopicDesc.vue?vue&type=style&index=0&id=53bea329&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bea329",
  null
  
)

export default component.exports